// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3P3nH","title":"AfterFrontImage_title__24qOH"};